import { Outlet } from 'react-router-dom'

export default function TeacherLayout() {
    return <Outlet />
}
